<template>
  <div>
    <div class="content-title">资金汇总</div>
    <div style="padding: 20px; border: 1px solid #e4d6d6;" class="content-tool">
      <div>
        <span class="available-money-class">累计成功发放金额: {{ providerTotalMoney.outcomeMoney }}元</span>
        <span class="available-money-class">累计服务费: {{ providerTotalMoney.serviceCost }}元</span>
      </div>
      <div>
        <div class="content-tool--nav">
          <div class="content-tool--title fl">公司：</div>
          <el-select v-model="providerId" class="fl" style="margin-right: 30px;" filterable>
            <el-option v-for="p in providers" :key="p.providerId" :label="p.providerName" :value="p.providerId"></el-option>
          </el-select>
          <div class="content-tool--title fl" style="width: 80px;">发放时间：</div>
          <el-date-picker v-model="times" type="daterange" :picker-options="pickerOptions" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" align="right" style="margin: 0px 20px 0px 0px;"></el-date-picker>
          <el-button type="primary" class="content-tool--qry el-button-reset" @click="search">查询</el-button>
          <el-button class="content-tool--reset el-button-reset" @click="reset">重置</el-button>
          <!-- <el-button @click="downloadExcel" type="primary" style="margin-left: 20px;">下载excel文件</el-button> -->
        </div>
      </div>
    </div>
    <div class="content-table">
      <el-table :data="moneyviews" size='medium' tooltip-effect="dark">
        <el-table-column label="发放时间" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.opTime | parseCreateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="opTotal" label="发放总额" align="right"></el-table-column>
        <el-table-column prop="opPeople" label="发放人数" align="center"></el-table-column>
        <el-table-column prop="opSucTotal" label="发放成功金额" align="right"></el-table-column>
        <el-table-column prop="opSucPeople" label="发放成功人数" align="center"></el-table-column>
        <el-table-column prop="opFailTotal" label="发放失败金额" align="right"></el-table-column>
        <el-table-column prop="opFailPeople" label="发放失败人数" align="center"></el-table-column>
        <!-- <el-table-column prop="payDate" label="付款日期" align="center"></el-table-column> -->
        <el-table-column prop="providerFee" label="服务费" align="right"></el-table-column>
        <el-table-column prop="providerName" label="公司" width="280px"></el-table-column>
        <el-table-column prop="platformName" label="平台" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
import { parseTime } from '../utils';

export default {
  name: 'moneyview',
  data() {
    return {
      moneyviews: [],
      providerTotalMoney: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      times: [],
      providerId: null,
      providers: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 30));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 90));
            picker.$emit('pick', [start, end]);
          },
        }],
      },
    };
  },
  filters: {
    parseCreateTime(time) {
      if (!time) {
        return '';
      }
      return parseTime(new Date(time));
    },
  },
  mounted() {
    this.fetchMoneyView();
    this.fetchProviderTotalMoney();
    this.fetchProviders();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.fetchProviderTotalMoney();
      this.fetchMoneyView();
    },
    fetchMoneyView() {
      const params = {};
      if (this.times && this.times.length === 2) {
        params.beginTime = new Date(this.times[0]).getTime();
        params.endTime = new Date(this.times[1]).getTime();
      }
      params.providerId = this.providerId;
      params.index = this.currentPage;
      params.size = this.pageSize;
      console.log('params', params);
      api.fetchMoneyView({
        params: {
          params,
        },
      }).then((res) => {
        console.log('fetchMoneyView', res);
        this.moneyviews = res.data;
        this.total = res.count;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    fetchProviderTotalMoney() {
      api.fetchProviderTotalMoney({
        params: {
          params: {
            providerId: this.providerId,
          },
        },
      }).then((res) => {
        if (!res) {
          return;
        }
        this.providerTotalMoney = res;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchMoneyView();
    },
    reset() {
      this.times = [];
      this.currentPage = 1;
      this.providerId = null;
      this.search();
    },
    fetchProviders() {
      api.fetchProviders().then((res) => {
        console.log(res);
        if (!res) {
          return;
        }
        this.providers = res;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.available-money-class {
  font-size: 18px;
  color: #188fff;
  margin-right: 40px;
  letter-spacing: 3px;
  font-weight: bold;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    // width: 30%;
    padding: 30px 10px 10px 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
    padding: 0px 17px 20px 17px;
    margin: 0px 20px 20px 20px;
  }
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>

<style scoped>
.el-form .el-form-item{
  margin-bottom: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/moneyview.vue